module.exports = __webpack_public_path__ + "img/accordion-mask-elastic-default.57d527cf.jpg";